<template>
    <span class="word-elem po container"
        :class="getWordClass"
        :style="getWordStyle"
        v-show="wordCanShow"
        v-html="currentHtml"></span>
</template>

<script>
	import BaseElem from "@/components/st_comps/st_comp/comps/StElem/BaseElem"

    export default {
        name: 'word',
        extends: BaseElem,
        data () {
            return {
                tx: null,
                _mode: null,
                isTextIn : false,
                canTextShow: false,
                currentText: ""
            }
        },
        props: { 
            wordMode: {
                type: String
            }
        },
        watch: {
            canIShow: {
                handler (nv, ov) {
                    let operate = 0;
                    if (this.canIShow === true) {
                        operate = 1;
                    } else if (ov != undefined && this.canIShow === false) {
                        operate = -1;
                    }
                    if (this.mode['text']){
                        let tx = this.$util.copy( this.mode['text'] );
                        if ( this.$util.typeOf( tx ) == "array" ) {
                            tx = JSON.stringify(tx);
                        }
                        if (this.selfWordMode == "normal" && tx.indexOf("#usertext#") > -1) {
                            this.$store.commit("setUserTextDisplayState", this.$store.state.userTextDisplayState + operate)
                        } else if (this.selfWordMode == "normal" && tx.indexOf("#lrc#") > -1) {
                            // this.$store.commit("setCurrentWord",{
                            //     "lrcDisplay": this.$store.state.wordCur.lrcDisplay + operate
                            // })
                        }
                    }
                    if (this.mode['text']){
                        if (this.$util.typeOf(this.mode['text']) == "string"){
                            this.tx = this.mode['text']
                        } else if (this.$util.typeOf(this.mode['text']) == "array") {
                            for (let i = 0 ; i < this.mode['text'].length ; i++) {
                                let tx = this.getText(this.mode['text'][i]);
                                if (tx){
                                    this.tx = this.mode['text'][i];
                                    break;
                                }
                            }
                        }
                    } else {
                        this.tx = "#title#"
                    }
                },
                immediate: true
            },
            usertitle: {
                handler (nv, ov) {
                    if (nv) {
                        this.getCurrentText();
                    }
                },
                immediate: true
            },
            title: {
                handler (nv, ov) {
                    if (nv) {
                        this.getCurrentText();
                    }
                },
                immediate: true
            },
            currentUserText: {
                handler (nv, ov) {
                    if (nv !== undefined){
                        this.getCurrentText();
                    }
                },
                immediate: true
            }
        },
        created () {
            this._mode = this.mode;
            // if (this.mode['text']){
            //     if (this.$util.typeOf(this.mode['text']) == "string"){
            //         this.tx = this.mode['text']
            //     } else if (this.$util.typeOf(this.mode['text']) == "array") {
            //         for (let i = 0 ; i < this.mode['text'].length ; i++) {
            //             let tx = this.getText(this.mode['text'][i]);
            //             if (tx){
            //                 this.tx = this.mode['text'][i];
            //                 break;
            //             }
            //         }
            //     }
            // } else {
            //     this.tx = "#title#"
            // }
        },
        computed: {
            currentHtml () {
                if (this.cssHtml) {
                    return '<div style="display: none;">' + this.cssHtml + '</div>' + this.currentText;
                }
                return this.currentText;
            },
            wordCanShow () {
                let canshow = true;
                if (this.selfWordMode == 'usertext') {
                    canshow = this.canTextShow && this.$store.state.userTextDisplayState == 0;
                }
                return canshow;
            },
            defaultTextMode () {
                let currentMode = this.$store.state.theme || {};
                return (currentMode['mode'] && currentMode['mode']['text']) || {};
            },
            usertitle () {
                return this.$store.state.data && this.$store.state.data['ti'] || ""
            },
            title () {
				return this.$store.state.data && this.$store.state.data['ti'] || this.$store.state.theme && this.$store.state.theme['name'];
			},
            currentUserText () {
                if (this.selfWordMode == "usertext"){
                    return (this.$store.state.imageCur != null && this.$store.state.images && this.$store.state.images[ this.$store.state.imageCur ])['tx'] || "";
                } else {
                    return this.currentPhoto.tx || "";
                }
            },
            getWordClass () {
                let _class = {}
                if (this.selfWordMode == "usertext"){
                    if (this.currentText && this.canTextShow) {
                        this.isTextIn = true;
                        _class = {'usertext-fadein': true};
                    } else if (this.isTextIn) {
                        _class = {'usertext-fadeout': true};
                    }
                }
                Object.assign(_class, this.elemClass);
                return _class;
            },
            selfWordMode () {
                let mode = "normal";
                if (this.wordMode) {
                    return this.wordMode;
                }
                if (this.canIShow === undefined && this.tx){
                    if (this.tx.indexOf("#usertext#") > -1) {
                        mode = "usertext";
                    } else if (this.tx.indexOf("#lrc#") > -1) {
                        mode = "lrc";
                    }
                } else if (this.tx === "#title#" || this.tx === "#usertitle#") { // 纯title适配title
                    mode = "title";
                }
                return mode;
            },
            getWordStyle () {
                let s = {
                        "text-align": "center",
                        "vertical-align": "middle"
                    },
                    mode = this._mode;
                if (this.selfWordMode == "title"){ // title默认样式
                    s = {
                        "display": "flex",
                        "justify-content": "center",
                        "align-items": "center",
                        "font-size": "30px",
                        "text-align": "center",
                        "font-weight": "bold",
                        "letter-spacing": "2px",
                    }
                } else if (this.selfWordMode == "usertext") {
                    s = {
                        "pointer-events": "none",
                        "z-index": "11",
                        "fontSize": "28px",
                        "textShadow": "0 0 5px rgba(39, 36, 36, .6), 0 0 10px rgba(39, 36, 36, .6), 0 0 15px rgba(39, 36, 36, .6), 0 0 40px rgba(39, 36, 36, .6), 0 0 70px rgba(39, 36, 36, .6)",
                        // "textShadow": "4px 4px 0 black, 4px -4px 0 black, -4px -4px 0 black, -4px 4px 0 black, 4px 3px 0 black, 4px -3px 0 black, -4px -3px 0 black, -4px 3px 0 black, 4px 2px 0 black, 4px -2px 0 black, -4px -2px 0 black, -4px 2px 0 black, 4px 1px 0 black, 4px -1px 0 black, -4px -1px 0 black, -4px 1px 0 black, 4px 0px 0 black, 4px 0px 0 black, -4px 0px 0 black, -4px 0px 0 black, 3px 4px 0 black, 3px -4px 0 black, -3px -4px 0 black, -3px 4px 0 black, 3px 3px 0 black, 3px -3px 0 black, -3px -3px 0 black, -3px 3px 0 black, 3px 2px 0 black, 3px -2px 0 black, -3px -2px 0 black, -3px 2px 0 black, 3px 1px 0 black, 3px -1px 0 black, -3px -1px 0 black, -3px 1px 0 black, 3px 0px 0 black, 3px 0px 0 black, -3px 0px 0 black, -3px 0px 0 black, 2px 4px 0 black, 2px -4px 0 black, -2px -4px 0 black, -2px 4px 0 black, 2px 3px 0 black, 2px -3px 0 black, -2px -3px 0 black, -2px 3px 0 black, 2px 2px 0 black, 2px -2px 0 black, -2px -2px 0 black, -2px 2px 0 black, 2px 1px 0 black, 2px -1px 0 black, -2px -1px 0 black, -2px 1px 0 black, 2px 0px 0 black, 2px 0px 0 black, -2px 0px 0 black, -2px 0px 0 black, 1px 4px 0 black, 1px -4px 0 black, -1px -4px 0 black, -1px 4px 0 black, 1px 3px 0 black, 1px -3px 0 black, -1px -3px 0 black, -1px 3px 0 black, 1px 2px 0 black, 1px -2px 0 black, -1px -2px 0 black, -1px 2px 0 black, 1px 1px 0 black, 1px -1px 0 black, -1px -1px 0 black, -1px 1px 0 black, 1px 0px 0 black, 1px 0px 0 black, -1px 0px 0 black, -1px 0px 0 black, 0px 4px 0 black, 0px -4px 0 black, 0px -4px 0 black, 0px 4px 0 black, 0px 3px 0 black, 0px -3px 0 black, 0px -3px 0 black, 0px 3px 0 black, 0px 2px 0 black, 0px -2px 0 black, 0px -2px 0 black, 0px 2px 0 black, 0px 1px 0 black, 0px -1px 0 black, 0px -1px 0 black, 0px 1px 0 black",
                        "color": "#ffffff",
                        "text-align": "center",
                        "white-space": "pre-wrap",
                        "letter-spacing": "3px",
                        "font-weight": "bold",
                        "line-height": "38px",
                        "opacity": "0"
                    }
                    if (this.defaultTextMode['color']){
                        mode['color'] = this.defaultTextMode['color']
                        s['color'] = this.defaultTextMode['color']
                    }
                    if (this.defaultTextMode['textShadowColor']){
                        mode['textShadowColor'] = this.defaultTextMode['textShadowColor']
                    }
                    if (this.defaultTextMode['bottom']){
                        mode['pos'] = [null, null, this.defaultTextMode['bottom'], 0];
                    }
                    if (this.defaultTextMode['style']) {
                        s = Object.assign(s, this.defaultTextMode['style']);
                    }
                }
				if (mode['textShadowColor']) {
					s['textShadow'] = "0 0 5px "+ mode['textShadowColor'] +", 0 0 10px "+ mode['textShadowColor'] +", 0 0 15px "+ mode['textShadowColor'] +", 0 0 40px "+ mode['textShadowColor'] +", 0 0 70px " + mode['textShadowColor'];
					// s['textShadow'] = "4px 4px 0 "+ mode['textShadowColor'] +", 4px -4px 0 "+ mode['textShadowColor'] +", -4px -4px 0 "+ mode['textShadowColor'] +", -4px 4px 0 "+ mode['textShadowColor'] +", 4px 3px 0 "+ mode['textShadowColor'] +", 4px -3px 0 "+ mode['textShadowColor'] +", -4px -3px 0 "+ mode['textShadowColor'] +", -4px 3px 0 "+ mode['textShadowColor'] +", 4px 2px 0 "+ mode['textShadowColor'] +", 4px -2px 0 "+ mode['textShadowColor'] +", -4px -2px 0 "+ mode['textShadowColor'] +", -4px 2px 0 "+ mode['textShadowColor'] +", 4px 1px 0 "+ mode['textShadowColor'] +", 4px -1px 0 "+ mode['textShadowColor'] +", -4px -1px 0 "+ mode['textShadowColor'] +", -4px 1px 0 "+ mode['textShadowColor'] +", 4px 0px 0 "+ mode['textShadowColor'] +", 4px 0px 0 "+ mode['textShadowColor'] +", -4px 0px 0 "+ mode['textShadowColor'] +", -4px 0px 0 "+ mode['textShadowColor'] +", 3px 4px 0 "+ mode['textShadowColor'] +", 3px -4px 0 "+ mode['textShadowColor'] +", -3px -4px 0 "+ mode['textShadowColor'] +", -3px 4px 0 "+ mode['textShadowColor'] +", 3px 3px 0 "+ mode['textShadowColor'] +", 3px -3px 0 "+ mode['textShadowColor'] +", -3px -3px 0 "+ mode['textShadowColor'] +", -3px 3px 0 "+ mode['textShadowColor'] +", 3px 2px 0 "+ mode['textShadowColor'] +", 3px -2px 0 "+ mode['textShadowColor'] +", -3px -2px 0 "+ mode['textShadowColor'] +", -3px 2px 0 "+ mode['textShadowColor'] +", 3px 1px 0 "+ mode['textShadowColor'] +", 3px -1px 0 "+ mode['textShadowColor'] +", -3px -1px 0 "+ mode['textShadowColor'] +", -3px 1px 0 "+ mode['textShadowColor'] +", 3px 0px 0 "+ mode['textShadowColor'] +", 3px 0px 0 "+ mode['textShadowColor'] +", -3px 0px 0 "+ mode['textShadowColor'] +", -3px 0px 0 "+ mode['textShadowColor'] +", 2px 4px 0 "+ mode['textShadowColor'] +", 2px -4px 0 "+ mode['textShadowColor'] +", -2px -4px 0 "+ mode['textShadowColor'] +", -2px 4px 0 "+ mode['textShadowColor'] +", 2px 3px 0 "+ mode['textShadowColor'] +", 2px -3px 0 "+ mode['textShadowColor'] +", -2px -3px 0 "+ mode['textShadowColor'] +", -2px 3px 0 "+ mode['textShadowColor'] +", 2px 2px 0 "+ mode['textShadowColor'] +", 2px -2px 0 "+ mode['textShadowColor'] +", -2px -2px 0 "+ mode['textShadowColor'] +", -2px 2px 0 "+ mode['textShadowColor'] +", 2px 1px 0 "+ mode['textShadowColor'] +", 2px -1px 0 "+ mode['textShadowColor'] +", -2px -1px 0 "+ mode['textShadowColor'] +", -2px 1px 0 "+ mode['textShadowColor'] +", 2px 0px 0 "+ mode['textShadowColor'] +", 2px 0px 0 "+ mode['textShadowColor'] +", -2px 0px 0 "+ mode['textShadowColor'] +", -2px 0px 0 "+ mode['textShadowColor'] +", 1px 4px 0 "+ mode['textShadowColor'] +", 1px -4px 0 "+ mode['textShadowColor'] +", -1px -4px 0 "+ mode['textShadowColor'] +", -1px 4px 0 "+ mode['textShadowColor'] +", 1px 3px 0 "+ mode['textShadowColor'] +", 1px -3px 0 "+ mode['textShadowColor'] +", -1px -3px 0 "+ mode['textShadowColor'] +", -1px 3px 0 "+ mode['textShadowColor'] +", 1px 2px 0 "+ mode['textShadowColor'] +", 1px -2px 0 "+ mode['textShadowColor'] +", -1px -2px 0 "+ mode['textShadowColor'] +", -1px 2px 0 "+ mode['textShadowColor'] +", 1px 1px 0 "+ mode['textShadowColor'] +", 1px -1px 0 "+ mode['textShadowColor'] +", -1px -1px 0 "+ mode['textShadowColor'] +", -1px 1px 0 "+ mode['textShadowColor'] +", 1px 0px 0 "+ mode['textShadowColor'] +", 1px 0px 0 "+ mode['textShadowColor'] +", -1px 0px 0 "+ mode['textShadowColor'] +", -1px 0px 0 "+ mode['textShadowColor'] +", 0px 4px 0 "+ mode['textShadowColor'] +", 0px -4px 0 "+ mode['textShadowColor'] +", 0px -4px 0 "+ mode['textShadowColor'] +", 0px 4px 0 "+ mode['textShadowColor'] +", 0px 3px 0 "+ mode['textShadowColor'] +", 0px -3px 0 "+ mode['textShadowColor'] +", 0px -3px 0 "+ mode['textShadowColor'] +", 0px 3px 0 "+ mode['textShadowColor'] +", 0px 2px 0 "+ mode['textShadowColor'] +", 0px -2px 0 "+ mode['textShadowColor'] +", 0px -2px 0 "+ mode['textShadowColor'] +", 0px 2px 0 "+ mode['textShadowColor'] +", 0px 1px 0 "+ mode['textShadowColor'] +", 0px -1px 0 "+ mode['textShadowColor'] +", 0px -1px 0 "+ mode['textShadowColor'] +", 0px 1px 0 "+ mode['textShadowColor'];
				}

                // 默认是填满屏幕
                if (!mode['size']) {
                    mode['size'] = ['100%', '100%'];
                }
                if (!mode['pos']) {
                    mode['pos'] = [0, null, null, 0];
                }

                s = Object.assign(s, this.getItemStyle(mode));

                // 做条件判断更改页面style状态
				s = this.doConditionStyle(s);

                s = this.$util.pxTransform(s, 'style');
                return s;
            },
        },
        methods: {
            getCurrentText () { // 获取当前显示文字
                if (!this.tx){
                    return "";
                }
                
                let tx = this.$util.replaceKeyWords(this.tx);

                tx = this.getText(tx);

                if (this.selfWordMode == "usertext"){
                    if (tx.length > 13) {
                        let split_num = Math.round(tx.length/2);
                        tx = tx.slice(0, split_num) + "<br />" + tx.slice(split_num)
                    }
                    // 切换文字时控制显隐
                    this.canTextShow = false;
                    setTimeout(() => {
                        this.canTextShow = true;
                    }, 300);
                }
                this.currentText = tx || "";
			},
            getText(tx) {
                // 预设关键字
                if (tx.indexOf("#lrc#") > -1){
                    tx = tx.replace("#lrc#", this.$store.state.wordCur.lrc || "")
                }
                if (tx.indexOf("#title#") > -1){
                    tx = tx.replace("#title#", this.title || "我的甜豆相册")
                }
                if (tx.indexOf("#usertitle#") > -1){
                    tx = tx.replace("#usertitle#", this.usertitle)
                }
                if (tx.indexOf("#usertext#") > -1) {
                    tx = tx.replace("#usertext#", this.currentUserText || "")
                }
                // 变量关键字
                tx = this.replaceReg(tx);
                
                return tx;
            },
        },
    }
</script>

<style>
.word-elem{
    font-family: "arial", "微软雅黑";
    width: initial;
}
.usertext-fadein {
    animation: fadein 1s ease-out both;
}
.usertext-fadeout {
    animation: fadeout 1s ease-out both;
}
</style>